import styled from "@emotion/styled"
import { mq, Text, theme } from "@pallet-hq/hegel"
import { FlexColumn } from "components/atoms"

type TaggedBlockProps = {
    label: string
    tags: string[]
}

// Returns the first N elements in an array that don't exceed the character count threshold
const pickElementsByLength = (array: string[], threshold: number) =>
    array.reduce(
        (accumulator, current) =>
            [...accumulator, current].join("").length < threshold
                ? [...accumulator, current]
                : accumulator,
        [] as string[]
    )

const TaggedBlock = ({ label, tags }: TaggedBlockProps) => {
    const shortenedTags = pickElementsByLength(tags, 40)

    return (
        <Wrapper>
            <FlexColumn>
                <StyledTitle variant="uiLarge500" mb="xsmall">
                    {label}
                </StyledTitle>
                <Tags>
                    {shortenedTags.map((tag, index) => (
                        <StyledTag key={index}>{tag}</StyledTag>
                    ))}
                </Tags>
            </FlexColumn>
        </Wrapper>
    )
}

export default TaggedBlock

const Wrapper = styled.div`
    display: inline-flex;
    align-items: center;
    border: 1px solid ${theme.colors.gray200};
    border-radius: 16px;

    ${mq({ padding: [theme.space.xsmall, theme.space.medium] })};
`

const StyledTitle = styled(Text)`
    ${mq({
        fontSize: [8, 16],
        lineHeight: ["11px", "20px"],
    })}
`

const Tags = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`

const StyledTag = styled.div`
    background: ${theme.colors.gray200};
    white-space: nowrap;

    ${mq({
        fontSize: [8, 14],
        lineHeight: ["11px", "20px"],
        padding: ["2px 4px", "4px 8px"],
        borderRadius: [112, 192],
    })}
`
